<template>
    <!-- 前台页面更新 -->
     <!-- 头部操作 -->
    <el-button-group>
        
        <el-button type="primary" size="large"  @click="batchPublish">
            <el-icon><Finished /></el-icon>&nbsp;
            批量发布
        </el-button>
    </el-button-group>
    <!-- 表格组件 -->
      <el-table
          class="table"
          ref="multipleTableRef"
          :data="tableData"
          :height="tableHeight"
          border
          stripe 
          :header-cell-style="{ background: '#f5f7fa' }"
          style="width: 100%; margin-top: 10px"
          v-loading="loading"
          element-loading-text="发布中"
          @selection-change="handleSelectionChange"
        >
        <el-table-column type="selection" width="55" />
          <el-table-column
            prop="name"
            label="页面名称"
            align="left"
            fixed="left">
          </el-table-column>
          <el-table-column
                label="操作"
                width="200px"
                align="center">
                <template #default="scope">
                <el-button  type="primary"  size="default" plain @click="releaseFnc(scope.row)">发布</el-button>
                </template>
              </el-table-column>
        </el-table>
</template>

<script>
import { reactive, toRefs,h, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { PublishHomeMobile, PublishPtzsbHtmlMobile, PublishZkzsbHtmlMobile,
    PublishCkzsbHtmlMobile, PublishWlycjyHtmlMobile, PublishHome, CreatePtzsbCategoryHtml,
    CreateZkzsbCategoryHtml, CreateCkzsbCategoryHtml, CreateWlycjyCategoryHtml, PublishHtml,GetPublishCategory } from "network/pageUpdate.js";
export default {
    name: "PageUpdate",
    props: {
        tableMaxHeight: Number,
    },
    setup() {
        //这里定义一个结构体，用来保存项目信息
        const data = reactive({
            //表格数据
            tableData: [{
                name: '【手机端】专升本首页',
                  id:1
            }, {
                name: '【手机端】普通专升本',
                  id: 2
            }, {
                name: '【手机端】自考专升本',
                  id: 3
            },{
                name: '【手机端】成考专升本',
                  id: 4
            },{
                name: '【手机端】开放教育',
                  id: 5
            },{
                name: '【电脑端】专升本首页',
                 id: 6
            },{
                name: '【电脑端】普通专升本',
                  id: 7
            },{
                name: '【电脑端】自考专升本',
                  id: 8
            },{
                name: '【电脑端】成考专升本',
                  id: 9
            }, {
                name: '【电脑端】开放教育',
                  id: 10
            }],
            loading:false, //加载中
            multipleSelection:[]
        });
        //挂载后调用函数获取项目数据
        onMounted(() => {
            getPublishCategory(); 
        });
        //发布
        const releaseFnc = (e) => {
               ElMessageBox({
                title: "发布",
                message: h("p", null, [
                    h("span", null, "是否发布"),
                    h(
                        "b",
                        { style: "color: #fd5252;font-size:16px;" },
                        `${e.name}`
                    ),
                    h("span", null, "？ "),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        // 开启按钮加载
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "确认中",
                        // 删除接口
                        done();
                        postHtml(e.id)
                        
                    } else {
                        done();
                    }
                },
            })
                // .then(() => {
                //     postHtml(e.id);
                // })
                .catch(() => {
                    ElMessage("取消发布");
                });
        };
        const postHtml = async (id) => {
            data.loading = true
            let result = {};
            if(id == 1 ){
               result = await PublishHomeMobile();
            }else if(id ==2){ 
                result = await PublishPtzsbHtmlMobile();
            } else if (id == 3) {
                result = await PublishZkzsbHtmlMobile();
            } else if (id == 4) {
                result = await PublishCkzsbHtmlMobile();
            } else if (id == 5) {
                result = await PublishWlycjyHtmlMobile();
            } else if (id == 6) {
                result = await PublishHome();
            } else if (id == 7) {
                result = await CreatePtzsbCategoryHtml();
            } else if (id == 8) {
                result = await CreateZkzsbCategoryHtml();
            } else if (id == 9) {
                result = await CreateCkzsbCategoryHtml();
            } else if (id == 10) {
                result = await CreateWlycjyCategoryHtml();
            }
            if (result.code == 1) {
                ElMessageBox.alert(result.message,"发布", {
                    confirmButtonText: "确定",
                });
            } else {
                ElMessageBox.alert(result.message, "发布", {
                    confirmButtonText: "确定",
                });
            }
            data.loading = false
        };
        const handleSelectionChange = (val) => {
            data.multipleSelection = val
            console.log(data.multipleSelection);
        };
        const getPublishCategory = async () => {
            let res = await GetPublishCategory()
        };
        const batchPublish = () => {
            if (data.multipleSelection && data.multipleSelection.length == 0) {
                ElMessage.error("请选择一个页面!");
                return;
            }
            let ids = []
            data.multipleSelection.forEach((ele)=>{
                ids.push(ele.id)
            })
            ElMessageBox({
                title: "发布",
                message: h("p", null, [
                    h("span", null, "确定将选中的【"),
                    h(
                    "b",
                    { style: "color: #fd5252;font-size:16px" },
                    `${data.multipleSelection.length}`
                    ),
                    h("span", null, "】个页面发布吗？ "),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        // 开启按钮加载
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "发布中",
                        // 发布接口
                        
                        PublishHtml(ids)
                        .then((result) => {
                        if (result && result.code == 1) {
                            done();
                            let str = ''
                            result?.result?.forEach((item,index)=>{
                                str = str + ` ${index + 1}.` + item
                            })
                            str = str?str:result.message?result.message:'发布成功'
                            ElMessageBox.alert(str, "发布", {
                                confirmButtonText: "确认",
                            });
                           
                        } else {
                            done();
                            let str = ''

                            result?.result?.forEach((item,index)=>{
                                str = str + `${index + 1}.` + item
                            })
                            str = str?str:result.message?result.message:'发布失败'
                            ElMessageBox.alert(str, "发布", {
                                confirmButtonText: "确认",
                            });
                        }
                        })
                        .catch((err) => {
                        done();
                        let str = ''
                        err?.result?.forEach((item,index)=>{
                                str = str + `${index + 1}.` + item
                            })
                        str = str?str:err.message?err.message:'发布失败'
                        ElMessageBox.alert(str, "发布", {
                                confirmButtonText: "确认",
                            });
                        })
                        
                    } else {
                        done();
                    }
                },
            }).catch(() => {
                ElMessage("取消发布");
            });
        };
        return {
            //解构Data结构体，让模板可以直接调用Data里面的对象
            ...toRefs(data),
            releaseFnc,
            handleSelectionChange,
            batchPublish,
            getPublishCategory
        };
    },
};
</script>


